import React from "react";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import cashIcon from "../../../images/gameplay_ui/icons/cash_icon.svg";
import locoIcon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import AddRemoveButtons from "../AddRemoveButtons";
import GameButtonWithText from "../GameButtonWithText";
import GameData from "../../../gameplay/model/GameData";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import x from "../../../images/icons/close_red.svg";

class BuyWorkhourPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0
    }

    let HRIndex = UtilsFunctions.getRoleNameIndex("Зам. по кадрам и социальным вопросам");
    this.isHR = UtilsFunctions.playerHasRole(HRIndex);
  }

  addBrigades(diff) {
    this.setState({
      count: diff
    });
  }

  render() {
    let bgStyle = {
      zIndex: "10",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      width: "184px",
      height: "150px",
      padding: "5px",
      borderRadius: "3px",
      background: "#F2F2F2"
    }
    let posStyle = this.props.isRight ? {left: "10px"} : {right: "10px"};

    let hasEnoughMoney = GameData.CurrentGame.cash > (this.state.count + 1) * 2000000;
    let inBounds = this.state.count + this.props.additionalChips < this.props.brigades * 2; // 50% от бригад * 4

    return <div style={{...bgStyle, ...posStyle}}>
      <CurrencyCard icon={locoIcon} value={"Сверхурочные"} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <img src={x} alt="X" className="x" onClick={() => {
        this.props.onClose(this)
      }}/>
      <CurrencyCard icon={cashIcon} value={2000000} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <AddRemoveButtons
        asInputNumber={true}
        max={this.props.brigades * 2}
        width={130}
        value={this.state.count}
        onValueChanged={this.addBrigades.bind(this)}
        isCanBuy={this.isHR && hasEnoughMoney && inBounds}
        isCanSell={this.isHR && this.state.count > 0}
      />
      <GameButtonWithText width={164}
                          height={30}
                          colorStart={"#8CED00"}
                          colorEnd={"#66AE04"}
                          title={"КУПИТЬ"}
                          disabled={!this.isHR || this.state.count === 0}
                          onClick={() => {
                            agent.GamePlay.buyAdditionalWorkhour(
                              this.props.teamID, {
                                id: this.props.id, type: this.props.type,
                                count: this.state.count
                              }, () => {});
                            this.props.parent.popup = null;
                            this.setState(
                              {
                                count: 0
                              }
                            )
                          }}/>
    </div>
  }
}

export default BuyWorkhourPopup;
